import addEntity from "./addEntity";
import autoMove from "./autoMove";
import blueprintBuild from "./blueprintBuild";
import blueprintCancel from "./blueprintCancel";
import blueprintMove from "./blueprintMove";
import blueprintSelect from "./blueprintSelect";
import bordersDraw from "./bordersDraw";
import bordersRemove from "./bordersRemove";
import bordersUpdate from "./bordersUpdate";
import cancelAutoMove from "./cancelAutoMove";
import clearReflectors from "./clearReflectors";
import completeTutorial from "./completeTutorial";
import completeTutorialStep from "./completeTutorialStep";
import continueVictory from "./continueVictory";
import cycleReflector from "./cycleReflector";
import deactivateWeapon from "./deactivateWeapon";
import decreaseJobPriority from "./decreaseJobPriority";
import destroy from "./destroy";
import destroyPos from "./destroyPos";
import executeRemoveBuilding from "./executeRemoveBuilding";
import farmGrowthUpdateTile from "./farmGrowthUpdateTile";
import fireWeapon from "./fireWeapon";
import increaseJobPriority from "./increaseJobPriority";
import loadGame from "./loadGame";
import logEvent from "./logEvent";
import logMessage from "./logMessage";
import makeMeRich from "./makeMeRich";
import modifyResource from "./modifyResource";
import move from "./move";
import moveCursor from "./moveCursor";
import newGame from "./newGame";
import playerTookTurn from "./playerTookTurn";
import rebuild from "./rebuild";
import reduceMorale from "./reduceMorale";
import removeEntities from "./removeEntities";
import removeEntity from "./removeEntity";
import removeReflector from "./removeReflector";
import resetTutorials from "./resetTutorials";
import roadUpdateTile from "./roadUpdateTile";
import rotateEntity from "./rotateEntity";
import setAutoMovePath from "./setAutoMovePath";
import setAutoMovePathToCursor from "./setAutoMovePathToCursor";
import setCursorPos from "./setCursorPos";
import setJobPriority from "./setJobPriority";
import shieldCharge from "./shieldCharge";
import shieldDischarge from "./shieldDischarge";
import startTutorial from "./startTutorial";
import targetWeapon from "./targetWeapon";
import temperatureDecrease from "./temperatureDecrease";
import temperatureIncrease from "./temperatureIncrease";
import toggleDisabled from "./toggleDisabled";
import undoTurn from "./undoTurn";
import updateEntity from "./updateEntity";

export default {
  addEntity,
  autoMove,
  blueprintBuild,
  blueprintCancel,
  blueprintMove,
  blueprintSelect,
  bordersDraw,
  bordersRemove,
  bordersUpdate,
  cancelAutoMove,
  clearReflectors,
  completeTutorial,
  completeTutorialStep,
  continueVictory,
  cycleReflector,
  deactivateWeapon,
  decreaseJobPriority,
  destroy,
  destroyPos,
  executeRemoveBuilding,
  farmGrowthUpdateTile,
  fireWeapon,
  increaseJobPriority,
  loadGame,
  logEvent,
  logMessage,
  makeMeRich,
  modifyResource,
  move,
  moveCursor,
  newGame,
  playerTookTurn,
  rebuild,
  reduceMorale,
  removeEntities,
  removeEntity,
  removeReflector,
  resetTutorials,
  roadUpdateTile,
  rotateEntity,
  setAutoMovePath,
  setAutoMovePathToCursor,
  setCursorPos,
  setJobPriority,
  shieldCharge,
  shieldDischarge,
  startTutorial,
  targetWeapon,
  temperatureDecrease,
  temperatureIncrease,
  toggleDisabled,
  undoTurn,
  updateEntity,
};
